<div class="breadcrumb">
  <div class="item" *ngFor="let item of breadcrumb; let i = index">
    <div class="arrow" *ngIf="i !== 0">
      <span
        class="icon-Arrow-Front"
        [ngClass]="{
          'last-breadcrumb': i === breadcrumb.length - 1 && i !== 0
        }"
      ></span>
    </div>
    <div
      class="label text-tiny"
      (click)="goToRoute(item.route)"
      [ngClass]="{
        'last-breadcrumb': i === breadcrumb.length - 1 && i !== 0
      }"
    >
      {{ item.label }}
    </div>
  </div>
</div>
